import { render, staticRenderFns } from "./CartBox.vue?vue&type=template&id=380b252e"
import script from "./CartBox.vue?vue&type=script&lang=js"
export * from "./CartBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports